export default __webpack_public_path__ + "static/media/yoga.3167635a.jpg";